import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { Location } from '../models/location';
import { ServerData } from '../models/paging/server-data';
import * as moment from 'moment';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';

@Injectable()
export class InspectionService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }


  //this.filter.companyId, this.filter.locationId, this.filter.tabletUser_Id, this.filter.start_Date, this.filter.end_Date, this.filter.job_No, this.filter.serial_Num
  public getResults(page: Page, company_Id: number, locationId: number, tabletUser_Id: number,
    start_Date, end_Date, job_No: string, serial_Num: string, categoryId: number): Promise<PagedData<Location>> {
    const pagedData = new PagedData<Location>();

    return new Promise((resolve, reject) => {
      //console.log("LocationId: " + locationId)
      //console.log("job_No: " + job_No)
      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + locationId ;
      params += "&tabletUser_Id=" + tabletUser_Id;
      params += '&start_Date=' + moment(start_Date).format('YYYY-MM-DD');
      params += '&end_Date=' + moment(end_Date).format('YYYY-MM-DD');
      params += "&Job_No=" + job_No;
      params += "&serial_Num=" + serial_Num;
      params += "&categoryId=" + categoryId;

      this.http.get<ServerData>(environment.apiUrl + 'inspection/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });


  }
}
